"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHomeBannerApiClient = createHomeBannerApiClient;
const axios_client_1 = require("@invivodf/axios-client");
const infra_1 = require("../infra");
function createHomeBannerApiClient(apiHost, options) {
    const client = (0, axios_client_1.createAxiosClient)(apiHost, options);
    async function findByPartnerId(partnerId) {
        try {
            const response = await client.get(`/v1/partners/${partnerId}/home-banner`);
            return response.data;
        }
        catch (err) {
            (0, infra_1.handleError)(err);
        }
    }
    async function createOrUpdateHomeBanner(partnerId, homeBanner) {
        try {
            const response = await client.post(`/v1/partners/${partnerId}/home-banner`, homeBanner);
            return response.data;
        }
        catch (err) {
            (0, infra_1.handleError)(err);
        }
    }
    return {
        findByPartnerId,
        createOrUpdateHomeBanner
    };
}
